'use client'

import { useEffect, useState } from 'react'

interface UseCountdownOptions {
  targetDate?: Date | null
  refreshIntervalMs?: number
}

export const useCountdown = ({
  targetDate,
  refreshIntervalMs = 60_000
}: UseCountdownOptions) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    isExpired: false
  })

  useEffect(() => {
    if (!targetDate) {
      return undefined
    }

    const calculate = () => {
      const now = Date.now()
      const target = targetDate.getTime()
      const difference = target - now

      if (difference <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, isExpired: true })
        return
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))

      setTimeLeft({ days, hours, minutes, isExpired: false })
    }

    calculate()
    const interval = setInterval(calculate, refreshIntervalMs)

    return () => clearInterval(interval)
  }, [targetDate, refreshIntervalMs])

  return timeLeft
}
